import { Switch as MySwitch } from '@chakra-ui/react';

export function Switch({
  checked,
  onCheckedChange,
  disabled,
}: {
  disabled?: boolean;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}) {
  return (
    <MySwitch.Root
      checked={checked}
      onCheckedChange={(e) => onCheckedChange?.(e.checked)}
      disabled={disabled ? disabled : false}
    >
      <MySwitch.HiddenInput />
      <MySwitch.Control>
        <MySwitch.Thumb></MySwitch.Thumb>
      </MySwitch.Control>
    </MySwitch.Root>
  );
}
